import { BiddingGame } from '../models/bidding-game'
import { BiddingGameDto } from '../dtos/bidding-game.dto'
import { gamePropsMapper } from './game-props.mapper'
import { Bid } from '../models/bid'

export const biddingGameMapper = {
  mapToBiddingGame(biddingGameDto: BiddingGameDto): BiddingGame {
    return new BiddingGame({
      ...biddingGameDto,
      ...gamePropsMapper.mapToGameProps(biddingGameDto),
      userBidOptions: biddingGameDto.userBidOptions.map(
        (option) => new Bid(option),
      ),
    })
  },
}
